import * as React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import { CreatorScreen } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen';
import HeaderContainer from '../Containers/HeaderContainer';
import CustomThemeProvider from '../ThemeProvider';
import SvgDesignCanvas from '../Components/Editor/SvgDesignCanvas';
import XxlPrintLayout from '../Layouts/XxlPrintLayout';
import SocialShareDialog from '../Components/SocialShare/SocialShareDialog';
import SendEmailDialog from '../Components/SendEmailDialog/SendEmailDialog';

const CustomCreatorScreen = (props) => {
  return (
    <CreatorScreen
      {...props}
      Layout={XxlPrintLayout}
      renderProductParts={() => null}
      renderOptionsList={() => null}
      renderShoppingCart={() => null}
      renderHeader={() => <HeaderContainer />}
      renderVisualization={() => <SvgDesignCanvas />}
      renderSendEmail={() => <SendEmailDialog />}
      renderCustomScreenComponents={() => <SocialShareDialog />}
    />
  );
};

const CustomConfiguratorScreen = (props) => {
  return (
    <ConnectedConfiguratorScreen
      {...props}
      CreatorScreen={CustomCreatorScreen}
      ThemeProvider={CustomThemeProvider}
    />
  );
};

export default CustomConfiguratorScreen;
